module.exports = __webpack_public_path__ + "img/34_10.f464cf7f.png";